import { NavCard } from "../../v2024/card"
import { Link } from "gatsby"
import React from "react"

export const ProductsSection = ({ title, items, comparative }) => {
    return (
        <li className="menu-options__options__option">
            <span>{title}</span>
            <div className="option__menu">
                <div className="container">
                    <div className="option__menu__section">
                        {items.map(item =>
                            <div className="section__column">
                                <span className="section__column__title">{item.section_title}</span>
                                {item.section_items.map(element =>
                                    <>
                                        {element.image ?
                                            <NavCard
                                                title={element.title} link={element.url} icon={element.image}
                                                description={element.description} noArrow colortype={element.color}
                                            />
                                            :
                                            <NavCard
                                                title={element.title} link={element.url}
                                                description={element.description} size="sm"
                                            />
                                        }
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="option__menu__section option__menu__section--gray">
                        <div className="section__column">
                            <span className="section__column__title">{comparative.section_title}</span>
                            {comparative.section_items.map(item =>
                                <Link className="section__column__links" to={item.url}>{item.title}</Link>
                            )}
                            <Link className="section__column__view-more" to={comparative.see_all.url}>{comparative.see_all.text}</Link>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    )
}